export const defaultState = {
  isFetching: false,
  hasFailed: false,
  errorMsg: "",
  data: [],
  plusTests: [],
  modal: {},
};
